import React, { Component } from 'react'
import "../../css/general-style.css"
import { AiFillPrinter, AiOutlineWarning } from "react-icons/ai"
import Select from 'react-select';
import DashModalV2 from '../DashModalV2'
import { getInformationWithDataV3 } from '../../services/CABE';
import { getValueCookie } from '../../services/cookieService';
import { PriceList } from './PriceList';
import { getPrintHeaderCompany } from '../../functions/companyInformation';
import LoadingWindow from '../../components/LoadingWindow';
import { FormatQueryReturnDateForReport, getActualDateUTC, getDateFromReports } from '../../functions/dateFormat';
import ExcelDocument from '../ExcelDocument';
import { getDataSet } from '../../functions/generateDataSetExcel';

/**
 * PRICELISTV3-2026-10-17 — "Print Price Levels" V3.
 *
 * The original (PriceListModal.js, left untouched) prints SAGE prices through /Items/get; the ticket of
 * 2026-10-16 showed those do not match Price Management (the N3 list a salesperson sends to customers).
 * This version reads /v3/pricing/price-list (RDS-only, product_pricing) instead:
 *   - Mayaland prints Mayaland's prices, Altitude prints Altitude's own prices (no mixing).
 *   - Levels 1-3 only.
 *   - Only active products that have a price at the chosen level are printed. The ones left out are
 *     counted and listed in the modal so nobody sends a list believing it is complete.
 * Same PDF component (PriceList.js), same Excel helper and same layout as the original report.
 * To remove: delete this file, the import and the <PriceListModalV3 /> block in pages/Inventory.js.
 */
export class PriceListModalV3 extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
        this._requestSeq = 0;
    }

    state = {
        showModal: false,
        companyPrintHeader: getPrintHeaderCompany(),
        selectOptions: [
            { value: 1, label: 'Price Level 1' },
            { value: 2, label: 'Price Level 2' },
            { value: 3, label: 'Price Level 3' }
        ],
        PriceLevel: 1,
        ProductLines: [],
        ProductsList: [],
        MissingCodes: [],
        loadError: '',
        selectedAllProdLines: true,
        Customer: ''
    }

    handleModalOpen = async () => {
        await this.setState({ showModal: true })
        await this.GetProducts(this.state.PriceLevel)
    }

    handleModalClose = () => {
        this.setState({ showModal: false })
    }

    onChangeLevel = async (e) => {
        if (!e) return
        await this.setState({ PriceLevel: e.value })
        await this.GetProducts(e.value)
    }

    async GetProducts(level) {
        // Only the latest request may update the screen (switching levels quickly must not show stale prices).
        const seq = ++this._requestSeq
        await this.ModalLoading.current.showState(true);
        let items = []
        let missing = []
        let loadError = ''
        try {
            const response = await getInformationWithDataV3('/v3/pricing/price-list', {
                idCompany: Number(getValueCookie('CompanyId')),
                priceLevel: level
            })
            if (response && response.status && response.status.code === 1 && response.data) {
                items = response.data.items || []
                missing = response.data.missing || []
            } else {
                loadError = 'The price list could not be loaded. Please try again.'
            }
        } catch (error) {
            console.error('PriceListModalV3 load failed:', error)
            loadError = 'The price list could not be loaded. Please try again.'
        }
        if (seq !== this._requestSeq) {
            return
        }

        // _line is only used for the product-line pills/filter; the printed ProductLineDesc stays as it is.
        const ProductLines = []
        for (const item of items) {
            item._line = item.ProductLineDesc ? item.ProductLineDesc : '(No product line)'
            let found = false
            for (const line of ProductLines) {
                if (line.label === item._line) { found = true; break }
            }
            if (!found) ProductLines.push({ label: item._line, selected: true })
        }
        ProductLines.sort((a, b) => a.label.localeCompare(b.label))

        await this.setState({ ProductLines: ProductLines, ProductsList: items, MissingCodes: missing, loadError: loadError, selectedAllProdLines: true })
        await this.ModalLoading.current.showState(false);
    }

    checkAllInv = async (e, actualStat) => {
        const temporal = this.state.ProductLines
        temporal.forEach(element => { element.selected = !actualStat })
        await this.setState({ ProductLines: temporal, selectedAllProdLines: !actualStat })
    }

    checkSpecificProdLine = async (e, actualStat, ProdLine) => {
        const temporal = this.state.ProductLines
        for (const line of temporal) {
            if (line.label === ProdLine) line.selected = !actualStat
        }
        let all = true
        for (const line of temporal) {
            if (!line.selected) { all = false; break }
        }
        await this.setState({ ProductLines: temporal, selectedAllProdLines: all })
    }

    onChange = e => {
        this.setState({ Customer: e.target.value })
    }

    getPrintProducts() {
        if (this.state.selectedAllProdLines) {
            return this.state.ProductsList
        }
        const selected = {}
        for (const line of this.state.ProductLines) {
            if (line.selected) selected[line.label] = true
        }
        return this.state.ProductsList.filter(item => selected[item._line])
    }

    render() {
        const labelStyle = {
            fontSize: '0.75rem', fontWeight: 700, color: '#64748B',
            textTransform: 'uppercase', letterSpacing: '0.4px',
            display: 'block', marginBottom: '6px',
        };
        const sectionTitle = {
            fontSize: '0.75rem', fontWeight: 700, color: '#64748B',
            textTransform: 'uppercase', letterSpacing: '0.6px',
            borderBottom: '1px solid #E2E8F0', paddingBottom: '6px', marginBottom: '12px',
        };
        const printProducts = this.getPrintProducts()
        const missing = this.state.MissingCodes
        const missingPreview = missing.slice(0, 12).join(', ') + (missing.length > 12 ? ', ...' : '')
        let selectedOption = null
        for (const option of this.state.selectOptions) {
            if (option.value === this.state.PriceLevel) selectedOption = option
        }

        return (
            <React.Fragment>
                <LoadingWindow ref={this.ModalLoading} />

                {/* Trigger button */}
                <button
                    hidden={this.props.hidden}
                    id={this.props.id}
                    disabled={this.props.disabled}
                    type="button"
                    onClick={() => this.handleModalOpen()}
                    style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                        border: 'none', borderRadius: '10px', color: 'white',
                        padding: '0 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                        cursor: 'pointer', display: 'flex', alignItems: 'center',
                        gap: '0.4rem', height: '100%', whiteSpace: 'nowrap',
                    }}
                >
                    <AiFillPrinter /> {this.props.titleButton}
                </button>

                {/* Modal */}
                <DashModalV2
                    title="Print Price Levels (Price Management)"
                    subtitle="Prices come from Price Management for the current company"
                    show={this.state.showModal}
                    onClose={() => this.handleModalClose()}
                    size="xl"
                    footer={
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <PriceList
                                id={"PriceListPrintV3"}
                                colorButton="blueButton"
                                title="Price Level List"
                                companyLogo={getValueCookie('DocumentsLogo')}
                                OrderTitle="Items Price List"
                                contactInfo={this.state.companyPrintHeader}
                                OrderInfo1={["Customer: ", this.state.Customer, "Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Print by: ", getValueCookie('userName'), "", ""]}
                                headerTable={["Item Code", "", "Product Line", "Description", "", "Unit\nPrice*"]}
                                bodyTable={printProducts}
                                headerBodyTable={["itemCode", "", "ProductLineDesc", "abbreviatedDesc", "dolar", "UnitPrice"]}
                                bottomInfo={[]}
                                styleColumns={["ColumnaTextoNormalLeft", "Dolar", "ColumnaTextoLargo", "ColumnaTextoLargo3", "Dolar", "ColumnaPrecios"]}
                                hidden={false}
                                comment={"*These prices may change without prior notice"}
                                breakpoint={48}
                                keysDecimalFormat={["UnitPrice"]}
                                disabled={printProducts.length === 0}
                                titleButton='Print PDF'
                            />
                            <ExcelDocument
                                hidden={false}
                                id={"ExcelPriceListDataV3"}
                                data={getDataSet(printProducts, ["Item Code", "Product Line", "Description", "Unit Price"], ["itemCode", "ProductLineDesc", "abbreviatedDesc", "UnitPrice"])}
                                sheetname={"Level " + this.state.PriceLevel}
                                archname={"Price List Level " + this.state.PriceLevel + " " + getValueCookie('Company') + " DATE " + getDateFromReports()}
                            />
                        </div>
                    }
                >
                    <div className="row g-4">

                        {/* Left column: Price Level + Customer */}
                        <div className="col-md-5">
                            <p style={sectionTitle}>Configuration</p>

                            <label style={labelStyle}>Price Level</label>
                            <Select
                                value={selectedOption}
                                options={this.state.selectOptions}
                                onChange={(e) => this.onChangeLevel(e)}
                                placeholder="Select Price Level"
                                styles={{
                                    control: (base) => ({ ...base, borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.9375rem' }),
                                }}
                            />

                            <label style={{ ...labelStyle, marginTop: '16px' }}>Customer (optional)</label>
                            <input
                                onChange={this.onChange}
                                id='CustomerOfListPriceReportV3'
                                type="text"
                                autoComplete='off'
                                placeholder="Customer name for the header…"
                                style={{
                                    width: '100%', padding: '0.625rem 0.875rem',
                                    border: '1.5px solid #E2E8F0', borderRadius: '8px',
                                    fontSize: '0.9375rem', outline: 'none',
                                }}
                                onFocus={e => e.target.style.borderColor = '#2563EB'}
                                onBlur={e => e.target.style.borderColor = '#E2E8F0'}
                            />

                            <p style={{ fontSize: '0.8125rem', color: '#0F172A', marginTop: '16px', marginBottom: '4px' }}>
                                <b>{printProducts.length}</b> products will be printed.
                            </p>
                            {this.state.loadError !== '' && (
                                <p style={{ fontSize: '0.8125rem', fontWeight: 700, color: '#991B1B', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <AiOutlineWarning /> {this.state.loadError}
                                </p>
                            )}
                            {missing.length > 0 && (
                                <p style={{ fontSize: '0.78rem', color: '#92400E', display: 'flex', alignItems: 'flex-start', gap: '4px', margin: 0 }}>
                                    <AiOutlineWarning style={{ marginTop: '2px', flexShrink: 0 }} />
                                    <span>{missing.length} active product{missing.length === 1 ? ' has' : 's have'} no Level {this.state.PriceLevel} price in Price Management and {missing.length === 1 ? 'is' : 'are'} not on this list: {missingPreview}</span>
                                </p>
                            )}
                        </div>

                        {/* Right column: Product Lines */}
                        <div className="col-md-7">
                            <p style={sectionTitle}>Product Lines</p>

                            {/* All toggle */}
                            <div style={{ marginBottom: '12px' }}>
                                <button
                                    type="button"
                                    onClick={(e) => this.checkAllInv(e, this.state.selectedAllProdLines)}
                                    style={{
                                        padding: '5px 14px', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
                                        border: '1.5px solid',
                                        borderColor: this.state.selectedAllProdLines ? '#2563EB' : '#E2E8F0',
                                        background: this.state.selectedAllProdLines ? '#EFF6FF' : '#F8FAFC',
                                        color: this.state.selectedAllProdLines ? '#1e40af' : '#64748B',
                                    }}
                                >
                                    {this.state.selectedAllProdLines ? '✓ All Product Lines' : 'All Product Lines'}
                                </button>
                            </div>

                            {/* Product line pills */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '280px', overflowY: 'auto', padding: '2px' }}>
                                {this.state.ProductLines.map((element, e) => (
                                    <button
                                        key={e}
                                        type="button"
                                        onClick={(ev) => this.checkSpecificProdLine(ev, element.selected, element.label)}
                                        style={{
                                            padding: '4px 12px', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer',
                                            border: '1.5px solid',
                                            borderColor: element.selected ? '#2563EB' : '#E2E8F0',
                                            background: element.selected ? '#EFF6FF' : '#F8FAFC',
                                            color: element.selected ? '#1e40af' : '#94A3B8',
                                            transition: 'all 0.15s',
                                        }}
                                    >
                                        {element.selected ? '✓ ' : ''}{element.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                </DashModalV2>

            </React.Fragment>
        );
    }
}
